import { ReminderTime } from '@gem/models/scheduledEventModel';

export const CallReminderMap = {
  [ReminderTime.FiveMinutes]: 'сall_reminder_5min',
  [ReminderTime.TenMinutes]: 'сall_reminder_10min',
  [ReminderTime.HalfHour]: 'сall_reminder_30min',
  [ReminderTime.OneHour]: 'сall_reminder_1h',
  [ReminderTime.TwoHours]: 'сall_reminder_2h',
  [ReminderTime.OneDay]: 'сall_reminder_1day',
};

export enum ScheduledCallsFormFields {
  Name = 'name',
  StartTsDate = 'startTsDate',
  StartTsTime = 'startTsTime',
  EndTsDate = 'endTsDate',
  EndTsTime = 'endTsTime',
  Reminder = 'reminder',
}

export const END_DATE_GAP = 1000 * 45 * 60;
